import React, { useEffect } from "react";
import { useStyles } from "./OrderHistoryListStyles";
import { Order } from "@dining/api-client";
import { appInsightsEvents, trackEvent, useAppStore } from "../../../common";
import { OrderHistoryCard } from "../OrderHistoryCard/OrderHistoryCard";
import { NoResultsMessage } from "../../shared";
import { Caption1 } from "@fluentui/react-components";

interface OrderListProps {
  ordersHistory: Order[];
}

export const OrderHistoryList = ({ ordersHistory }: OrderListProps) => {
  const styles = useStyles();
  const context = useAppStore((state) => state.context);
  const appInsights = useAppStore((state) => state.appInsights);
  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "OrderHistoryList",
    });
  }, [context, appInsights]);

  return (
    <div className={styles.container} data-testid="OrderHistoryList">
      <div className={styles.heading}>Order History</div>
      <div className={styles.infoContainer}>
        <span className={styles.infoIcon} aria-label="Information icon">
          i
        </span>
        <Caption1>
          Some dishes may not be available for re-ordering if the cafe is closed, the menu has
          changed, or the item is not available.
        </Caption1>
      </div>
      {ordersHistory && ordersHistory.length > 0 ? (
        <div className={styles.listContainer}>
          {ordersHistory.map((order: Order) => (
            <OrderHistoryCard key={order?.id} order={order} />
          ))}
        </div>
      ) : (
        <NoResultsMessage
          primaryMessage="Looks like you haven't placed any orders with us yet."
          secondaryMessage="Once you start ordering, your history will show up here. Check out today's menu to place your first order!"
          isOrderHistoryVisible={true}
        />
      )}
    </div>
  );
};
